<template>
  <div>
    <div class="my-top">
      <div class="personal-main">
        <div class="personal">
          <div class="personalimg">
            <img class="img" :src="headurl" alt="" />
          </div>
          <div>
            <div class="title">{{ username }}</div>
            <div class="integral">
              积分<span>{{ totalPoint }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="date">注册日期：<span>{{createTime}}</span></div> -->
      </div>
    </div>
    <van-cell title="积分卡激活" is-link @click="brand" />

    <van-cell
      v-for="(item, index) in menuList"
      :title="item.name"
      :key="index"
      is-link
      @click="goPage(item.path)"
    />
    <!-- <span>{{token}}</span> -->
  </div>
</template>

<script src="./dist/uplusapi.js"></script>
<script>
import UplusApi from "@uplus/uplus-api";
import { getUserInfo, totalPoint } from "@/api/api";
import config from "@/config/config";
import utils from "@/utils/utils";

export default {
  data() {
    return {
      appType: '',
      // token: "无token",
      instance: new UplusApi(),
      username: null,
      createTime: null,
      headurl: null,
      totalPoint: null,
      menuList: [
        {
          name: "地址管理",
          path: "/orders/shippingAddress",
        },
        {
          name: "我的订单",
          path: "/order",
        },
        {
          name: "我的收藏",
          path: "/orders/collection",
        },
        // {
        //     name: "积分卡激活",
        //     path: "/pointInvest",
        // },
        {
          name: "我的实物卡",
          path: "/cardlist",
        },
        {
          name: "通知公告",
          path: "/notice",
        },
        {
          name: "购物车",
          path: "/ShoppingCart",
        },
        {
          name: "客服",
          path: "/customerservice",
        },
        {
          name: "帮助中心",
          path: "/helpCenter",
        },
      ],
    };
  },

  methods: {
    async getUserInfo() {
      let params = {
        accessTokenPri:
          this.$cookies.get("hbscToken") || sessionStorage.getItem("hbscToken"),
      };

      let userInfo = await getUserInfo(params);
      this.username = userInfo.data.username;
      this.createTime = userInfo.data.createTime;
      this.headurl = userInfo.data.headurl;
    },
    async getTotalPoint() {
      let paramss = {
        memberId: "100",
      };
      let totalRes = await totalPoint(paramss);
      if (totalRes.code == "0000") {
        this.totalPoint = totalRes.data;
      }
    },
    async gioTrack(eventId) {
      let this_ = this;
      // alert("进入gioTrack")
      // debugger
      await this_.instance.initDeviceReady();
      return (
        this_.instance.upTraceModule &&
        this_.instance.upTraceModule.gioTrack &&
        this_.instance.upTraceModule
          .gioTrack({
            eventId,
          })
          .then(
            (res) => {
              // alert("查看是否调通")
              // alert(res.retInfo);
              // alert(eventId);
            },
            (err) => {
              console.log(res.retInfo);
            }
          )
      );
    },
    goPage(path) {
      // let params = {
      //   userId: userid,
      //   userName:aname,
      //   p:phone,
      //   fromPageUrl: url,
      //   sign: sign,
      //   pid: "zjapp",
      //   accountId: "jfzx",
      //   sceneId: "cj224",
      //   entranceId: "jt",
      //   fromPageTitle: "积分商城个人中心",
      // };
      let hbscToken = this.$cookies.get("hbscToken")||sessionStorage.getItem("hbscToken")
      let memberId = this.$cookies.get("memberId") || sessionStorage.getItem("memberId")
      if (hbscToken==null || memberId==null ) {
        this.$toast("请登录智家app或者小程序");
      } else {
        if (path.indexOf("customerservice") > -1) {
          if (this.appType === 'hrzj') {
            let str = utils.toService('zjapp', 'jfzx', 'cd0205', '积分商城个人中心', 'noUrl');
            this.instance.upVdnModule.goToPageForResult({
              url: `mpaas://CustomerService/?${str}#/zhijia`,
            }).then((res) => {
              console.log('result', res);
            }, (err) => {
              console.log('err', err);
            });
          } else {
            let str = utils.toService('zjapp', 'jfzx', 'cd0205', '积分商城个人中心');
            location.href = config.serviceUrl + str;
          }
        } else {
          this.$router.push({
            path: path,
          });
        }
      }
    },
    brand() {
      this.gioTrack("MB15994");
      this.$router.push({
        path: "/pointInvest",
      });
    },
  },

  mounted() {
    const userAgent = navigator.userAgent.toLocaleLowerCase();
    if (userAgent.includes("uplus")) {
      // app环境--智家
      this.appType = "hrzj";
    }
    this.getUserInfo();
    this.getTotalPoint();
  },
};
</script>

<style lang="scss" scoped>
.personal-main {
  background: #fff;
  padding: 30px;
  height: 100px;

  .personal {
    display: flex;

    .personalimg {
      margin-right: 20px;

      .img {
        width: 70px;
        height: 70px;
        border-radius: 100px;
      }
    }
  }
}

.title {
  color: #2283e2;
}

.integral {
  color: #dd3a1d;
  padding-top: 2px;
}

.date {
  color: #999;
  padding-top: 20px;
}
</style>
